import React, { createContext, useContext } from 'react';
import { ComputeResourceDiscoveryApi } from '../../api';
import { CRDKubernetesConfig } from '@internal/backstage-plugin-compute-resource-discovery-new-common';
import { useRefreshContext } from '../RefreshContext';

interface KubernetesContextProps {
  api: ComputeResourceDiscoveryApi;
  kubernetesConfigs: CRDKubernetesConfig[];
  projectCode: string;
  refreshContext?: ReturnType<typeof useRefreshContext>;
}

const KubernetesContext = createContext<KubernetesContextProps | undefined>(
  undefined,
);

export const useKubernetesContext = () => {
  const context = useContext(KubernetesContext);
  if (!context) {
    throw new Error(
      'KubernetesContext must be used within a KubernetesProvider',
    );
  }
  return context;
};

export const KubernetesContextProvider: React.FC<
  Omit<KubernetesContextProps, 'refreshContext'> & { children: React.ReactNode }
> = ({ api, kubernetesConfigs, projectCode, children }) => {
  const refreshContext = useRefreshContext();

  return (
    <KubernetesContext.Provider
      value={{
        api,
        kubernetesConfigs,
        projectCode,
        refreshContext,
      }}
    >
      {children}
    </KubernetesContext.Provider>
  );
};
